<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 24 24" fill="currentColor" >
    <path
      d="M24 8.5C24 7.122 22.879 6 21.5 6H19V0H5V6H2.5C1.122 6 0 7.122 0 8.5V21H5V24H19V21H24V8.5ZM6 1H18V6H6V1ZM18 23H6V15H18V23ZM23 20H19V14H5V20H1V8.5C1 7.673 1.673 7 2.5 7H21.5C22.327 7 23 7.673 23 8.5V20ZM15 10H19V11H15V10Z"
       />
  </svg>
</template>
<style scoped>
svg {
  color: #385660;
  transition: color 0.3s ease-in-out;
}
</style>
